export const CompleteProdutType = (prod: string) => {
  if (prod === 'CP') {
    return 'Crédito Parcelado';
  }

  if (prod === 'CV') {
    return 'Crédito à Vista';
  }

  if (prod === 'DB') {
    return 'Débito';
  }

  if (prod === 'PX') {
    return 'Pix';
  }

  return prod;
};
